












































































import { UseModal } from "@/components/root/modal";
import Vue from "vue";
import { ReportScheduleOption, ReportTemplate } from "../data/pdf/model";
import { pdf_state } from "../data/pdf/state.pdf";
import EmailListModalVue from "./EmailListModal.vue";
import ScheduledButtons from "./ScheduledButtons.vue";
export default Vue.extend({
  components: { ScheduledButtons },
  setup() {
    const { scheduled_reports, update_template } = pdf_state;

    const set_selected_schedule = async (
      report: ReportTemplate,
      schedule: ReportScheduleOption
    ) => {
      if (schedule == "none") {
        const res = await UseModal().showSimple({
          title: "Turn Off Report",
          desc: "Are you sure you want to turn off the report?",
          cancelBtnText: "Cancel",
          submitBtnText: "Turn Off",
          is_destructive: true,
        });
        if (res.type == "canceled") {
          return;
        }
      }
      update_template({
        ...report,
        scheduled: schedule,
      });
    };

    const remove_email = async (report: ReportTemplate, email: string) => {
      const res = await UseModal().showSimple({
        title: "Remove Email",
        desc: "Are you sure you want to remove this email?",
        cancelBtnText: "Cancel",
        submitBtnText: "Remove",
        is_destructive: true,
      });
      if (res.type == "success") {
        update_template({
          ...report,
          mailing_list: report.mailing_list.filter((e) => e != email),
        });
      }
    };

    const open_email_list_modal = async (report: ReportTemplate) => {
      const res = await UseModal().show(EmailListModalVue, {
        emails: report.mailing_list,
      });
      if (res.type == "success") {
        update_template({
          ...report,
          // @ts-ignore
          mailing_list: res.msg,
        });
      }
    };
    return {
      scheduled_reports,
      set_selected_schedule,
      open_email_list_modal,
      remove_email,
    };
  },
});
